import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const DealDetailLayout = () => {
     const navList = useNav();
  let {DealDetailBottomHeader, topDealNav} = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={DealDetailBottomHeader} topTabs={topDealNav} />
            <Outlet />
        </div>
    )
}

export default DealDetailLayout;